import { Primitive } from "./primitive";

export class AvatarPrimitive extends Primitive {

    public AvatarBlobPath?: string;
    public IsDefault: boolean = false;
    public IsEditable: boolean = false;
}
